import { View } from "binder"
import { FormBuilderComponentView } from "src/formBuilder/structure/element";
import { CheckboxElement } from "./checkbox-viewModel"

export class CheckboxView extends FormBuilderComponentView<CheckboxElement>{
    GetViewUniqueId(): string {
        return "V-2EEF8482-4D03-410A-960A-EE8014B4FD6C"
    }
    loadHtml(): string {
        let element = require('./checkbox.html').default;
        let style = require('./checkbox.less');
        return element;
    }
    constructor() {
       super();
    }

    public set Checked(v: boolean) { this._Checked = v; } public get Checked(): boolean { return this._Checked;} private _Checked: boolean;

}
